import { render, staticRenderFns } from "./pharmacy.vue?vue&type=template&id=50fcc7c2&scoped=true&"
import script from "./pharmacy.vue?vue&type=script&lang=js&"
export * from "./pharmacy.vue?vue&type=script&lang=js&"
import style0 from "./pharmacy.vue?vue&type=style&index=0&id=50fcc7c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fcc7c2",
  null
  
)

export default component.exports